import React, { useState, SetStateAction } from 'react'
import styled from 'styled-components'
import TextField from '@material-ui/core/TextField'
import { removeQuestion } from '../utils/ui.utils'
import moment from 'moment'
import orderBy from 'lodash/orderBy';
import { Flex } from '../styles/global'
import Button from '@material-ui/core/Button'

interface QuestionProps {
    question: any
    updateQuestions: SetStateAction<any>
}

export const SurveyQuestion = (props: QuestionProps) => {
    const { question, updateQuestions } = props
    const [currentQuestion, setQuestion] = useState({ ...question })

    const syncQuestions = (targetObj: any) => {
        updateQuestions((current: any) => {
            const arr = [...current.filter((item: any) => item.id !== targetObj.id), targetObj]
            return orderBy(arr, (o: any) => moment(o.created_at), ['asc'])
        })
    }

    const handleChange = (field: string, value: string) => {
        setQuestion((current: any) => {
            const updated = { ...current, [field]: value };
            syncQuestions(updated);
            return updated;
        })
    }

    return (
        <QuestionContainer>
            <FieldGroup>
                <Label>Question *</Label>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Enter the question text..."
                    value={currentQuestion.title || ""}
                    onChange={(e) => handleChange('title', e.target.value)}
                />
            </FieldGroup>

            <FieldGroup>
                <Label>Learn More Link (Optional)</Label>
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="https://..."
                    value={currentQuestion.info_link || ""}
                    onChange={(e) => handleChange('info_link', e.target.value)}
                />
            </FieldGroup>

            <ChoicesGrid>
                {['a', 'b', 'c', 'd', 'e', 'f'].map((id) => (
                    <ChoiceField key={id}>
                        <ChoiceLabel>
                            {id.toUpperCase()}
                        </ChoiceLabel>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder={`Option ${id.toUpperCase()}${['a', 'b'].includes(id) ? ' *' : ''}`}
                            value={currentQuestion[id] || ""}
                            onChange={(e) => handleChange(id, e.target.value)}
                        />
                    </ChoiceField>
                ))}
            </ChoicesGrid>

            <Flex justify="flex-end" alignItems="center" style={{ marginTop: '24px' }}>
                <DeleteButton
                    onClick={() => updateQuestions((current: any) => removeQuestion(current, currentQuestion))}
                >
                    Remove Question
                </DeleteButton>
            </Flex>
        </QuestionContainer>
    );
};

const QuestionContainer = styled.div``;

const FieldGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #4a5568;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const ChoicesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  background: #f8fafc;
  padding: 24px;
  border-radius: 8px;
  margin-top: 24px;
`;

const ChoiceField = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ChoiceLabel = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-weight: 800;
  font-size: 14px;
  transition: all 0.2s;
  background: #e2e8f0;
  color: #718096;
`;

const DeleteButton = styled(Button)`
  && {
    color: #e53e3e;
    font-weight: 600;
    text-transform: none;
    &:hover {
      background: #fff5f5;
    }
  }
`;
